import { createRoot } from 'react-dom/client';
import React from "react";
import PaymentPage from "../paymentShared/paymentPage";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";

const Initialise = () => {
	const ticketsPayment = document.getElementById("ticketsPayment");
	if (!ticketsPayment) {
		return;
	}
	const paymentData = JSON.parse(ticketsPayment.dataset.appPayment);
	const stripePromise = loadStripe(paymentData.publishableKey);

	const appearance = {
		theme: 'stripe'
	};

	const options = {
		clientSecret: paymentData.clientSecret,
		appearance
	};

	const root = createRoot(ticketsPayment);

	root.render(<Elements stripe={stripePromise} options={options}>
		<PaymentPage paymentData={paymentData} stripe={stripePromise} />
	</Elements>);
};

export default Initialise;
